import { render, staticRenderFns } from "./CocoLinkForm.vue?vue&type=template&id=2f407641&scoped=true&"
import script from "./CocoLinkForm.vue?vue&type=script&lang=ts&"
export * from "./CocoLinkForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f407641",
  null
  
)

export default component.exports